/**
 * Allowed values for package types
 */

export const PACKAGE_TYPE_COMPULSORY_HOMEWORK = 'homework';
export const PACKAGE_TYPE_OPTIONAL_HOMEWORK = 'optional-homework';
export const PACKAGE_TYPE_TARGETS = 'targets';
export const PACKAGE_TYPE_REVISION = 'revision';
export const PACKAGE_TYPE_PRACTICE = 'practice';
export const PACKAGE_TYPE_TRAINING_COMPULSORY = 'homework-training';
export const PACKAGE_TYPE_TRAINING_OPTIONAL = 'optional-homework-training';
export const PACKAGE_TYPE_TRAINING_TARGETS = 'targets-training';
